import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import { useFormik } from "formik";

const AssignedFormFilters = ({ onApply }) => {
  const initialValues = {
    status: [],
    roles: [],
    level: [],
  };

  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      onApply(values);
    },
  });

  // generic checkbox handler
  const handleCheckboxChange = (field) => (event) => {
    const { value, checked } = event.target;

    const updatedValues = checked
      ? [...formik.values[field], value]
      : formik.values[field].filter((item) => item !== value);

    formik.setFieldValue(field, updatedValues);
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {/* STATUS */}
        <FormGroup>
          <FormLabel>Status</FormLabel>
          <Box className="flex">
          <FormControlLabel
            label="Active"
            control={
              <Checkbox
                value="1"
                 checked={(formik.values.status || []).includes("1")}
                onChange={handleCheckboxChange("status")}
              />
            }
          />
          <FormControlLabel
            label="Inactive"
            control={
              <Checkbox
                value="0" 
                checked={(formik.values.status || []).includes("0")}
                onChange={handleCheckboxChange("status")}
              />
            }
          />
          </Box>
        </FormGroup>

        {/* ROLES */}
        <FormGroup sx={{ mt: 2 }}>
          <FormLabel>Roles</FormLabel>
          <Box className="flex">
          <FormControlLabel
            label="Editor"
            control={
              <Checkbox
                value="Editor"
                 checked={(formik.values.roles || []).includes("Editor")}
                onChange={handleCheckboxChange("roles")}
              />
            }
          />
          <FormControlLabel
            label="Medical Advisor"
            control={
              <Checkbox
                value="Medical Advisor"
                  checked={(formik.values.roles || []).includes("Medical Advisor")}
                onChange={handleCheckboxChange("roles")}
              />
            }
          />
            
          <FormControlLabel
            label="Manufacturer"
            control={
              <Checkbox
                value="Manufacturer"
                checked={(formik.values.roles || []).includes("Manufacturer")}
                onChange={handleCheckboxChange("roles")}
              />
            }
          />
          </Box>
        </FormGroup>

        {/* LEVEL */}
        <FormGroup sx={{ mt: 2 }}>
          <FormLabel>Level</FormLabel>
           <Box className="flex">
          <FormControlLabel
            label="3-Level"
            control={
              <Checkbox
                value="3-Level"
                checked={(formik.values.level || []).includes("3-Level")}
                onChange={handleCheckboxChange("level")}
              />
            }
          />
          <FormControlLabel
            label="2-Level"
            control={
              <Checkbox
                value="2-Level"
                 checked={(formik.values.level || []).includes("2-Level")}
                onChange={handleCheckboxChange("level")}
              />
            }
          />
          <FormControlLabel
            label="1-Level"
            control={
              <Checkbox
                value="1-Level"
                 checked={(formik.values.level || []).includes("1-Level")}
                onChange={handleCheckboxChange("level")}
              />
            }
          />
          </Box>
        </FormGroup>

        <Button type="submit" sx={{ mt: 2 }}>
          Apply
        </Button>
      </form>
    </Box>
  );
};

export default AssignedFormFilters;
